import { render, staticRenderFns } from "./TeamMatchesOverview.vue?vue&type=template&id=04db3b7a&scoped=true&"
import script from "./TeamMatchesOverview.vue?vue&type=script&lang=js&"
export * from "./TeamMatchesOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamMatchesOverview.vue?vue&type=style&index=0&id=04db3b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db3b7a",
  null
  
)

export default component.exports